import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=705fdad0&scoped=true"
var script = {}
import style0 from "./Navigation.vue?vue&type=style&index=0&id=705fdad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705fdad0",
  null
  
)

export default component.exports